import CartIcon from '../../assets/icons/CartIcon';
import useBasket from '../../hooks/basket/useBasket';
import useTheme from '../../hooks/ui/useTheme';
import useAppMethods from '../../hooks/utility/useAppMethods';

const OrderBasketButton = () => {
  const { basketItemsCount } = useBasket();
  const { toggleOrderBasketModal } = useAppMethods();
  const theme = useTheme();

  return (
    <button
      data-test="order-basket-button"
      className={buttonStyle}
      onClick={() => {
        toggleOrderBasketModal({
          openModal: true,
        });
      }}
    >
      <CartIcon color={theme.color.brand.text.primary} className="w-4 h-4" />
      {basketItemsCount > 0 && (
        <span data-test="order-basket-count" className={badgeStyle}>
          {basketItemsCount}
        </span>
      )}
    </button>
  );
};

export default OrderBasketButton;

const buttonStyle =
  'relative bg-secondary dark:bg-gray-700 rounded-full w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center hover:opacity-90 transition-opacity';
const badgeStyle =
  'absolute -top-1 -right-1 bg-brand-button-primary-background text-brand-button-primary-text text-[10px] font-bold rounded-full w-5 h-5 flex items-center justify-center';
